import React from 'react'
import '../Biochemistry/Biochemistry.css'
import common from '../../../assets/common.jpg'
import MegaNavbar from '../../../Components/MegaNavbar'

import AsimaCv from '../../../assets/CVs/Bioinformatics/AsimaCV.pdf'
import AsmabibiCv from '../../../assets/CVs/Bioinformatics/AsmaBibi_Cv.pdf'
import DrAishmaCv from '../../../assets/CVs/Bioinformatics/DrAishma_Cv.pdf'
import DrFarhatCv from '../../../assets/CVs/Bioinformatics/DrFarhat_Cv.pdf'
import DrNousheenCv from '../../../assets/CVs/Bioinformatics/DrNousheen_cv.pdf'

import Footer from '../../../Components/Footer'
// import TeacherCard from '../../../Components/TeacherCard'
const Bioinformatics = () => { 
  return (
    <>
    <MegaNavbar/>
    <section id="team" className="team section-bg">
        <div className="container">

      <div className="section-title">
        <h2>Bioinformatics</h2>
        
        <p>Faculty of Bioinformatics.</p>
      </div>

      <div className="row">

      


        <div className="col-lg-6">
          <div className="member d-flex align-items-start">
            <div className="teampic"><img src={common} className="img-fluid img-thumbnail" alt="" /></div>
            <div className="member-info">
              <h4>Dr. Asma Jamil</h4>
              <span>Lecturer Department of Bioinformatics</span>
               
              <p> Working as lecturer in Department of Bioinformatics, 
                 Benazir Bhutto Women Universit </p>
              <p className='my-icon'><i className="bi bi-envelope-at-fill"></i>   asimajamil@sbbwu.edu.pk  </p>    
              
              <div className="social">
                <a href={AsimaCv}><i class="bi bi-file-earmark-person-fill"></i></a>
                <a href=" https://scholar.google.com/citations?hl=en&user=ROMlGDQAAAAJ"><i className="bi bi-google"></i></a>
                <a href=""><i className="bi bi-linkedin"></i></a>
              </div>
            </div>
          </div>
        </div>



        <div className="col-lg-6">
          <div className="member d-flex align-items-start">
            <div className="teampic"><img src={common} className="img-fluid img-thumbnail" alt="" /></div>
            <div className="member-info">
              <h4>Dr. Asma Bibi  </h4>
              <span>Lecturer Department of Bioinformatics   </span>
              <p>Lecturer at Department of Bioinformatics Shaheed Benazir Bhutto Women University Peshawar. </p>
              <p className='my-icon'><i className="bi bi-envelope-at-fill"></i>   asmashah@sbbwu.edu.pk    </p>    
              <div className="social">
                <a href={AsmabibiCv}> <i class="bi bi-file-earmark-person-fill"></i></a>
                <a href=""><i className="bi bi-google"></i></a>
                <a href=""><i className="bi bi-linkedin"></i></a>
              </div>
            </div>
          </div>
        </div>



        <div className="col-lg-6">
          <div className="member d-flex align-items-start">
            <div className="teampic"><img src={common} className="img-fluid img-thumbnail" alt="" /></div>
            <div className="member-info">
              <h4>Dr. Aishma  khattak  </h4>
              <span>Assistant Professor Department of Bioinformatics </span>
              
              <p>Assistant Professor Department of Bioinformatics Shaheed Benazir Bhutto Women University   </p>
              <p className='my-icon'><i className="bi bi-envelope-at-fill"></i>   aishmakhattak@sbbwu.edu.pk    </p>    

              
              <div className="social">
                <a href={DrAishmaCv}> <i class="bi bi-file-earmark-person-fill"></i></a>
                <a href="https://scholar.google.com/citations?user=GE-IqjcAAAAJ&hl=en"><i className="bi bi-google"></i></a>
                <a href=""><i className="bi bi-linkedin"></i></a>       
              </div>
            </div>
          </div>
        </div>


        <div className="col-lg-6">
          <div className="member d-flex align-items-start">
            <div className="teampic"><img src={common} className="img-fluid img-thumbnail" alt="" /></div>
            <div className="member-info">
              <h4>Dr. Farhat Amin   </h4>
              <span>Associate Professor Department of Biochemistry</span>
              <p>HEC Approved Supervisor Department of Bioinformatics Shaheed Benazir Bhutto Women University </p>
              <p className='my-icon'><i className="bi bi-envelope-at-fill"></i>  farhat.humayun@sbbwu.edu.pk     </p>    
              <div className="social">
            <a href={DrFarhatCv}> <i class="bi bi-file-earmark-person-fill"></i></a>
                <a href="https://scholar.google.co.in/citations?user=xNSshlcAAAAJ&hl=en"><i className="bi bi-google"></i></a>
                <a href=""><i className="bi bi-linkedin"></i></a>
               </div>
            </div>
          </div>
        </div>
      
        <div className="col-lg-6">
          <div className="member d-flex align-items-start">
            <div className="teampic"><img src={common} className="img-fluid img-thumbnail" alt="" /></div>
            <div className="member-info">
              <h4>Dr. Nousheen Bibi   </h4>
              <span>Assistant Professor Department of Bioinformatics </span>
              <p>Assistant Professor Department of Bioinformatics Shaheed Benazir Bhutto Women university, Peshawar </p>
              <p className='my-icon'><i className="bi bi-envelope-at-fill"></i> drnosheenbibi@sbbwu.edu.pk   </p>    
              <div className="social">
            <a href={DrNousheenCv}> <i class="bi bi-file-earmark-person-fill"></i></a>
                <a href="https://scholar.google.co.in/citations?user=xNSshlcAAAAJ&hl=en"><i className="bi bi-google"></i></a>
                <a href=""><i className="bi bi-linkedin"></i></a>
               </div>
            </div>
          </div>
        </div>
       
       
        
       
       
        
        

        {/* Repeat the above structure for other team members */}

      </div>

    </div>
  </section>
      <Footer/>
    </>
  )
}

export default  Bioinformatics
